module.exports = __webpack_public_path__ + "static/media/6.acbdb7f1.svg";